'use client'

import React, { Suspense } from 'react'
import { HorizontalScroll } from './components/HorizontalScroll'

export default function Hero() {
  return (
    <Suspense fallback={
      <div className="flex min-h-screen items-center justify-center bg-brand-surface-dark">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-eskerium-blue"></div>
      </div>
    }>
      <HorizontalScroll />
    </Suspense>
  )
}